import styled from "styled-components";
import { windowWidth } from "@styles/global";

const FormContainer = styled.div`
`;

const OptionContainer = styled.div`
  padding-top: 15px;

  @media (min-width: ${windowWidth.tablet}) {
    width: 33%;
  }
`;

const PasswordContainer = styled.div`
  div {
    width: 95% !important;
  }
`;

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 10px;

  .MuiButton-root {
    background-color: #ff0000;

    &:hover {
      background-color: #df0000;
    }
  }
`;

export { OptionContainer, PasswordContainer, ButtonContainer, FormContainer };